import React, { useEffect, useState } from "react";
import { Col, Card, Row, Button } from "react-bootstrap";
import { FaEdit, FaPlusCircle } from "react-icons/fa";
import { RiNurseLine } from "react-icons/ri";
import MyLines from "./MyLines";
import FallRiskAssessment from "./FallRiskAssessment";
import NumericalPainScale from "./NumericalPainScale";
import TextEditor from "./TextEditor";
import VisitFollowupForm from "./VisitFollowupForm";
import { useDispatch, useSelector } from "react-redux";
import PainChart from "./PainChart";
import { GoSync } from "react-icons/go";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import Message from "./Message";
import {
  codeBlue,
  criticalResultAlert,
  fallingEventContent,
  nursingCarePlan,
} from "../data/nurseForms";
import { FaPersonFalling } from "react-icons/fa6";
import { MdFormatListBulleted } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FaRemoveFormat } from "react-icons/fa";
import { IoNotifications } from "react-icons/io5";
import Loader from "./Loader";
import FallRiskAssessmentAdult from "./FallRiskAssessmentAdult";

const VisitNurseSection = ({ visit, currentAge, patientVehicle, clinic }) => {
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [visitFollowups, setVisitFollowups] = useState(
    visit.nurseSection.visitFollowups,
  );
  const [missedFollowups, setMissedFollowups] = useState([]);
  const [painScore, setPainScore] = useState(visit.nurseSection.painScore);
  const [nurseNote, setNurseNote] = useState(visit.nurseSection.nurseNote);
  const [HDFS, setHDFS] = useState(visit.nurseSection.HDFS);
  const [hendrich, setHendrich] = useState(visit.nurseSection.hendrich);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const deleteItem = (id) => {
    setVisitFollowups(visitFollowups.filter((t) => t.followupId !== id));
  };
  const HDFSValue =
    Number(HDFS?.selectedAge || 0) +
    Number(HDFS?.selectedGender || 0) +
    Number(HDFS?.selectedMedication || 0) +
    Number(HDFS?.selectedSurgery || 0) +
    Number(HDFS?.selectedEnviromental || 0) +
    Number(HDFS?.selectedDiagnosis || 0) +
    Number(HDFS?.selectedCognitive || 0);

  const HDFSVarient =
    HDFSValue <= 11 ? "success" : HDFSValue <= 15 ? "warning" : "danger";

  const HDFSLabel =
    HDFSValue <= 11
      ? "Low Risk"
      : HDFSValue <= 15
      ? "Moderate Risk"
      : "High Risk";

  const hendrichValue =
    Number(hendrich?.selectedPostOp) +
    Number(hendrich?.selectedGait) +
    Number(hendrich?.selectedStroke) +
    Number(hendrich?.selectedConfusionTIA) +
    Number(hendrich?.selectedWeakness) +
    Number(hendrich?.selectedDizziness) +
    Number(hendrich?.selectedPsych) +
    Number(hendrich?.selectedConfused) +
    Number(hendrich?.selectedLimitations) +
    Number(hendrich?.selectedElimination) +
    Number(hendrich?.selectedMedication) +
    Number(hendrich?.selectedHearingVisual) +
    Number(hendrich?.selectedPreviousFalls) +
    Number(hendrich?.selectedAssistiveDevice) +
    Number(hendrich?.selectedAge70) +
    Number(hendrich?.selectedOsteoporosis);

  const hendrichVarient = hendrichValue >= 4 ? "danger" : "success";

  const hendrichLabel = hendrichValue >= 4 ? "High Risk" : "Low Risk";

  const dispatch = useDispatch();
  const updateNurseSection = async () => {
    // update Services
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visit._id}/updateVisitNurseSection`,
        {
          visitFollowups,
          painScore,
          nurseNote,
          HDFS,
          hendrich,
        },
        config,
      );
      // console.log(data);
      setHDFS(data.updatedHDFS);
      setHendrich(data.updatedHendrich);
      setVisitFollowups(data.updatedVisitFollowups);
      setPainScore(data.updatedPainScore);
      setNurseNote(data.updatedNurseNote);
      setLoading(false);
      setShowEdit(false);
      notify({
        title: "Nurse Data Update",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };

  const handleClear = () => {
    if (window.confirm("You will delete all text. Are you sure?")) {
      setNurseNote("");
    }
  };

  useEffect(() => {
    setMissedFollowups(
      clinic?.clinicFollowups
        ?.filter((t) => !t.isHide)
        ?.filter(
          (f) =>
            !visitFollowups.find(
              (ft) => ft.followupId.toString() === f._id.toString(),
            ),
        ),
    );
  }, [visitFollowups]);
  useEffect(() => {
    console.log(showEdit);
  }, [showEdit]);
  return (
    <div>
      <h4
        className="text-center text-white p-4 my-2"
        style={{ backgroundColor: "#54B4D3" }}
      >
        {" "}
        <RiNurseLine /> Nurse Section
      </h4>
      {showEdit ? (
        <div className="px-3">
          {/* ================= FALL RISK SCORE =================  */}
          {currentAge?.years < 18 ? (
            <>
              <Row className="text-center">
                <h2 className="col">Humpty Dumpty Fall Scale (HDFS)</h2>
              </Row>
              <FallRiskAssessment
                currentAge={currentAge}
                patientVehicle={patientVehicle}
                HDFS={HDFS}
                setHDFS={setHDFS}
              />
            </>
          ) : (
            <>
              <Row className="text-center">
                <h2 className="col">Hendrich Fall Risk Assessment</h2>
              </Row>
              <FallRiskAssessmentAdult
                hendrich={hendrich}
                setHendrich={setHendrich}
              />
            </>
          )}
          <MyLines type="dashed" />
          {/* ================= PAIN SCORE =================  */}
          <Row className="text-center">
            <h2 className="col">Numerical Pain Scale</h2>
          </Row>
          <NumericalPainScale
            painScore={Number(painScore)}
            setPainScore={setPainScore}
          />
          <MyLines type="dashed" />
          {/* ================= VISIT FOLLOWUPS =================  */}

          <Row className="text-center">
            <h2 className="col">Follow-Up Measures </h2>
          </Row>
          <div>
            <div className="p-4">
              {visitFollowups &&
                visitFollowups?.map((f) => (
                  <div key={f._id}>
                    <VisitFollowupForm
                      followupItem={f}
                      clinic={clinic}
                      deleteItem={deleteItem}
                    />
                  </div>
                ))}
            </div>
            {missedFollowups?.map((m) => (
              <Button
                variant="info"
                className="w-100 my-2"
                onClick={() =>
                  setVisitFollowups([
                    ...visitFollowups,
                    {
                      followupId: m._id,
                      followupLabel: m.label,
                      value: 0,
                    },
                  ])
                }
              >
                <FaPlusCircle /> {`Add ${m.label}`}
              </Button>
            ))}
          </div>
          <MyLines type="dashed" />
          {/* ================= NURSE NOTE =================  */}

          <Row className="text-center">
            <h2 className="col"> Other Notes</h2>
          </Row>
          <TextEditor text={nurseNote} setText={setNurseNote} rtl={true} />
          <Row dir="rtl" className="g-3 text-center text-primary my-2">
            <Col
              className="my-2"
              md={3}
              onClick={() => setNurseNote((prev) => prev + nursingCarePlan)}
            >
              <Card className="h-100 shadow-sm border border-primary">
                <Card.Body>
                  <Card.Text>
                    <MdFormatListBulleted /> إضافة نموذج خطة الرعاية التمريضية.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col
              className="my-2"
              md={3}
              onClick={() => setNurseNote((prev) => prev + criticalResultAlert)}
            >
              <Card className="h-100 shadow-sm border border-primary ">
                <Card.Body>
                  <Card.Text>
                    <IoNotifications /> إضافة نموذج الإبلاغ عن النتائج الحرجة
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col
              className="my-2"
              md={3}
              onClick={() => setNurseNote((prev) => prev + fallingEventContent)}
            >
              <Card className="h-100 shadow-sm border border-primary ">
                <Card.Body>
                  <Card.Text>
                    <FaPersonFalling /> إضافة نموذج تقييم سقوط مريض
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col
              className="my-2"
              md={3}
              onClick={() => setNurseNote((prev) => prev + codeBlue)}
            >
              <Card className="h-100 shadow-sm border border-primary ">
                <Card.Body>
                  <Card.Text>
                    <TbActivityHeartbeat /> إضافة نموذج الإنعاش القلبي الرئوي
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col className="my-2" md={3} onClick={handleClear}>
              <Card className="h-100 shadow-sm border border-danger text-danger">
                <Card.Body>
                  <Card.Text>
                    <FaRemoveFormat /> امسح الكل
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {error && (
            <Message
              children={`Nurse Update Err: ${error}`}
              variant={`danger`}
              setMessage={setError}
            />
          )}
          {/* ================= SUBMIT  =================  */}

          {loading ? (
            <Loader />
          ) : (
            <Row className="mt-2">
              <Col xs={12} className="text-center">
                <Button
                  style={{ backgroundColor: "#00abff", border: "none" }}
                  className="w-100 w-md-auto px-5"
                  onClick={() => updateNurseSection()}
                >
                  تحديث البيانات <GoSync />
                </Button>
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <div>
          {/* ========================== RISK FALL ASSESMENT ============================= */}
          {HDFS?.riskHandled ? (
            <>
              <Row className="text-center">
                <h2 className="col">Humpty Dumpty Fall Scale</h2>
              </Row>

              <div className="text-center p-3 rounded">
                <div className={`display-4 fw-bold text-${HDFSVarient}`}>
                  {HDFSValue}
                </div>

                <div className={`fw-semibold text-${HDFSVarient}`}>
                  {HDFSLabel}
                </div>

                <span
                  className={`text-${HDFSVarient}`}
                >{`All recommended measures are ${
                  HDFS?.riskHandled ? "" : "NOT"
                } done`}</span>
              </div>
            </>
          ) : (
            <>
              <Row className="text-center">
                <h2 className="col">Hendrich Fall Risk Assessment</h2>
              </Row>

              <div className="text-center p-3 rounded">
                <div className={`display-4 fw-bold text-${hendrichVarient}`}>
                  {hendrichValue}
                </div>

                <div className={`fw-semibold text-${hendrichVarient}`}>
                  {hendrichLabel}
                </div>

                <span
                  className={`text-${hendrichVarient}`}
                >{`All recommended measures are ${
                  hendrich?.riskHandled ? "" : "NOT"
                } done`}</span>
              </div>
            </>
          )}

          <MyLines type="dashed" />

          {/* ========================== PAIN ============================= */}
          <Row className="text-center">
            <h2 className="col">Pain Score</h2>
          </Row>
          <PainChart painScore={painScore} />
          <MyLines type={`dashed`} />
          {/* ========================== FOLLOWUPS ============================= */}
          <Row className="text-center">
            <h2 className="col">Follow-up Measurement</h2>
          </Row>
          <Row className="justify-content-center">
            {visitFollowups?.map((f) => {
              const isNormal =
                Number(f.followupLowerLimit) < Number(f.value) &&
                Number(f.value) < Number(f.followupUpperLimit)
                  ? true
                  : false;
              return (
                <Col key={f._id} className="col-auto my-2">
                  {/* <pre>{JSON.stringify(f, null, 2)}</pre> */}
                  <div
                    className={`border rounded p-3 ${
                      !isNormal
                        ? "border-danger text-danger"
                        : "border-success text-success"
                    }`}
                  >{`${f.followupLabel}: ${f.value}`}</div>
                </Col>
              );
            })}
          </Row>
          {/* ========================== NURSE NOTE ============================= */}
          {nurseNote && (
            <>
              <MyLines type={`dashed`} />
              <Row className="text-center">
                <h2 className="col">Nurse Notes</h2>
              </Row>
              <Row className="justify-content-center">
                <div
                  dir="rtl"
                  className="text-primary text-center"
                  dangerouslySetInnerHTML={{
                    __html: nurseNote,
                  }}
                />
              </Row>
            </>
          )}
          {/* ========================== FOOTER ============================= */}
          <div
            className="text-center mt-3 p-3 rounded border small text-muted"
            style={{
              backgroundColor: "#E8F7FB",
              border: "1px solid #54B4D3",
            }}
          >
            <div className="mb-2">
              <strong className="text-dark">
                {visit.nurseDetails?.firstName} {visit.nurseDetails?.lastName}
              </strong>{" "}
              <span>تم التسجيل بواسطة </span>
            </div>

            <Row className="justify-content-center gap-3 flex-wrap mb-3 g-0">
              <Col className="col-auto">
                <span
                  onClick={() => setShowEdit(true)}
                  className="fw-semibold text-primary"
                >
                  <FaEdit className="me-1" /> تعديل
                </span>
              </Col>
              <Col className="col-auto">
                <span className="fw-semibold">آخر تحديث: </span>
                {new Date(visit.nurseSection.updatedAt).toLocaleString("ar-EG")}
              </Col>
              <Col className="col-auto">
                <span className="fw-semibold">تاريخ الإنشاء: </span>
                {new Date(visit.nurseSection.createdAt).toLocaleString("ar-EG")}
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisitNurseSection;
